import { ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router";

import {
  RECORD_HEADER_LINK,
  RegistrarRecordHeader,
  RegistrarRecordViews,
} from "@/components/registrar/RegistrarRecordHeader";
import { Badge } from "@/components/ui/badge";

/**
 * Current-system reference only: one registrar record page's identity, its
 * queue, and its view row, with sample data. Every link stays on this page.
 * The record keeps the page's `h2`, so the specimen's own title is not a heading.
 */
export function RegistrarRecordSpecimen({ idPrefix }: { idPrefix: string }) {
  const heading = `${idPrefix}-record-page`;
  const here = `#${heading}`;
  return (
    <section aria-labelledby={heading} data-registrar-record-page-specimen className="grid min-w-0 gap-4">
      <div className="grid gap-1">
        <p className="eyebrow">Record page</p>
        <p id={heading} className="text-ui font-semibold text-foreground">One address per record</p>
        <p className="text-ui text-muted-foreground">
          A row opens its record as a page: the way back, the record as the page heading, one meta line, its status,
          and one view row. Sample links stay on this page.
        </p>
      </div>
      <div className="grid min-w-0 gap-2">
        <RegistrarRecordHeader
          listHref={here}
          listLabel="All students"
          eyebrow="Student record"
          title="Amina Yusuf"
          meta="Arabic Foundations · Fall 2026 · enrolled 2026-08-24"
          status={<Badge variant="success">Active</Badge>}
          nav={(
            <nav aria-label="Student queue" className="flex min-w-0 items-center gap-1">
              <Link to={here} className={`${RECORD_HEADER_LINK} px-2`}>
                <ChevronLeft className="size-4" strokeWidth={1.75} aria-hidden="true" />
                Previous student
              </Link>
              <span className="px-1 font-data text-meta tabular-nums text-muted-foreground">2 of 3</span>
              <Link to={here} className={`${RECORD_HEADER_LINK} px-2`}>
                Next student
                <ChevronRight className="size-4" strokeWidth={1.75} aria-hidden="true" />
              </Link>
            </nav>
          )}
        />
        <RegistrarRecordViews
          label="Student record views"
          active="record"
          views={[
            { key: "record", label: "Record", to: here },
            { key: "access", label: "Access", to: here },
            { key: "student", label: "Student", to: here },
            { key: "teaching", label: "Teaching", to: here },
          ]}
        />
      </div>
    </section>
  );
}
